

import React, { Component } from 'react';
import { Button, Modal} from "react-bootstrap";
import swal from 'sweetalert';
import Select from 'react-select';
import { view_ApiManager } from '../ApiManager/ApiManager';
import draftToHtml from 'draftjs-to-html';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw,ContentState, convertFromHTML  } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import '../GenericComponents/search.css';
import { editInternalNotes, internalNoteDetail } from '../Services/apiServices';

class EditInternalNotes extends Component {
    constructor(props) {
        super(props);
        let editorState = EditorState.createEmpty();
        if (this.props.data?.discussion_notes) {
            const contentBlock = convertFromHTML(this.props.data.discussion_notes);
            const contentState = ContentState.createFromBlockArray(
                contentBlock.contentBlocks,
                contentBlock.entityMap
            );
            editorState = EditorState.createWithContent(contentState);
        }
        this.state = {
            agenda: this.props.data?.agenda || '',
            participants:[],
            counselors: this.props.data?.participants || [],
            editorState,
            editorHtml: this.props.data?.discussion_notes || '',
            managers: this.props.data?.manager_ids || [],
            editorHtml: '',
            meetingDate: this.props.data?.meeting_date || '',
            startTime: this.props.data?.start_time || '',
            endTime: '',
            loading:false,
            dueDate: this.props.data?.due_date || '',
            editID:  this.props.data?.id || '',
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleManagerSelectChange = this.handleManagerSelectChange.bind(this);
        this.handleEditorChange = this.handleEditorChange.bind(this);
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleSubmit = async () => {
        const data ={
            counselors: this.state.counselors,
            managers: this.state.managers,
            agenda: this.state.agenda,
            meetingDate: this.state.meetingDate,
            startTime: this.state.startTime,
            endTime: this.state.endTime,
            dueDate: this.state.dueDate,
            discussionNotes: this.state.editorHtml,
            id: this.state.editID,
        }
        this.setState({loading: true})
        console.log(data)
        let result = await editInternalNotes({data});
        console.log('edited-notes', result)
        this.setState({loading:true})
        if (result.error) {
            swal({ text: result.error, icon: "warning", dangerMode: true });
        } else {
            swal("Success!", result.message , "success"); 
            this.clearValues();
            this.props.parentCallback(); 
        }
    }
    clearValues(){
        this.setState({
            agenda: '',
            participants:[],
            counselors:  [],
            editorHtml: '',
            managers:  [],
            editorHtml: '',
            meetingDate:  '',
            startTime:  '',
            endTime: '',
            loading: false,
            dueDate: '',
            editID: '',
        })
    }

    handleModal(){
        this.props.parentCallback(); 
    } 

    handleSelectChange(selectedOptions) {
        this.setState({
          counselors: selectedOptions || []
        });
    }
    handleManagerSelectChange(selectedOptions) {
        this.setState({
          managers: selectedOptions || []
        });
    }
    componentDidUpdate(prevProps) {
        // Update editorState if `discussion_notes` changes
        if (prevProps.data?.discussion_notes !== this.props.data?.discussion_notes && this.props.data?.discussion_notes) {
            const contentBlock = convertFromHTML(this.props.data.discussion_notes);
            const contentState = ContentState.createFromBlockArray(
                contentBlock.contentBlocks,
                contentBlock.entityMap
            );
            const editorState = EditorState.createWithContent(contentState);
            this.setState({ 
                editorState,
                editorHtml: this.props.data.discussion_notes,
                managers: this.props.data.manager_ids,
                counselors: this.props.data.participants,
                meetingDate: this.props.data.meeting_date,
                startTime: this.props.data.start_time,
                endTime: this.props.data.end_time,
                dueDate: this.props.data.due_date,
                editID: this.props.data.id,
                agenda: this.props.data.agenda,
            });
        }
    }

    getAllUsers = () => {
        let url = 'getAllUsers';
        view_ApiManager(url, 0, 0,(res) => {
            console.log('Get all Users',res);
            const participants = res.data.data.map(user => ({
                label: user.name, // Adjust the property name based on your API response
                value: user.id,
              }));
            this.setState({participants: participants})
        },(err) => {
            console.log(err);
        });
     }
     handleEditorChange(editorState) {
        this.setState({ editorState });
        const rawContentState = convertToRaw(editorState.getCurrentContent());
        const htmlContent = draftToHtml(rawContentState);
        console.log(htmlContent); // This logs the content as HTML
        this.setState({ editorHtml: htmlContent });
      }
     internalNotes = async () => {
        let result = await internalNoteDetail(this.props.id);
        console.log('internal-notes', result)
        if (result.error) {
            swal({ text: result.error, icon: "warning", dangerMode: true });
        } else {
            this.setState({
                detail:result.data.data,
                counselors:result.data.data['participants'],
                agenda:result.data.data['agenda'],
                managers:result.data.data['manager_ids'],
            })
        }
    }

    render(){ 
        const { editorState } = this.state;
        return(
        <>
        <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered 
         className="email-model" id="email-model" show={this.props.show} onHide={()=>this.handleModal()}>  

         <Modal.Header closeButton>
         <div className="text-center size-18 col-11 white sora-font">Internal Meeting Notes</div>
            </Modal.Header>  
            <Modal.Body className="ml-2 mr-2 mt-1 pb-1 pt-0">
            <form action='' onSubmit={this.handleSubmit}>
            <div className="row my-2">
            <div className="col-12 my-2 size-18">
                <label className="font-f-monst-sans fw-medium mb-0">Meeting Agenda:  </label>
                <input type='text' className="form-control form-note auto" placeholder="Please Enter" value={this.props.data['agenda']}
                name="agenda" onChange={this.handleChange} />
            </div>

            <div className="col-12 mt-2 size-18 my-2">
                <label className="font-f-monst-sans size-18 fw-medium mb-0">Meeting Manager</label>
                <Select
                isMulti
                name="participants"
                options={this.props.participants.filter(
                    option => !this.state.managers?.some(selected => selected.value === option.value)
                )}

                className="s-dropdown py-0 shadow-sm size-18 form-note chip-hide auto"
                classNamePrefix="select"
                onChange={this.handleManagerSelectChange}
                placeholder="Please Select"
                noOptionsMessage={() => "No options available"}
                value={this.state.managers}
                styles={this.customStyles}
            />
            </div>

            <div className="col-12 mt-2 size-18 my-2">
                <label className="font-f-monst-sans size-18 fw-medium mb-0">Meeting Attendees</label>
                <Select
                isMulti
                name="participants"
                options={this.props.participants.filter(
                    option => !this.props.data['participants']?.some(selected => selected.value === option.value)
                )}

                className="s-dropdown py-0 shadow-sm size-18 form-note chip-hide auto"
                classNamePrefix="select"
                onChange={this.handleSelectChange}
                placeholder="Please Select"
                noOptionsMessage={() => "No options available"}
                value={this.props.data['participants']}
                styles={this.customStyles}
            />
            </div>

             {/* Meeting Date */}
             <div className="col-4 my-2 size-18">
                <label className="font-f-monst-sans fw-medium mb-0">Meeting Date: </label>
                <input
                    type="date"
                    value={this.state.meetingDate}
                    className="form-control form-note"
                    name="meetingDate"
                    onChange={this.handleChange}
                />
            </div>

            <div className="col-3 ms-4 my-2 size-18">
                <label className="font-f-monst-sans fw-medium mb-0">Meeting Start Time</label>
                <input
                  value={this.state.startTime}
                    type="time"
                    className="form-control form-note"
                    name="startTime"
                    onChange={this.handleChange}
                />
            </div>

            <div className="col-3 ms-4 my-2 size-18">
                <label className="font-f-monst-sans fw-medium mb-0">Meeting End Time</label>
                <input
                    type="time"
                    value={this.state.endTime}
                    className="form-control form-note"
                    name="endTime"
                    min={this.state.endTime}
                    onChange={this.handleChange}
                />
            </div>

            <div className="col-3  my-2 size-18">
                <label className="font-f-monst-sans fw-medium mb-0">Meeting Due Date</label>
                <input
                    type="date"
                    className="form-control form-note"
                    name="dueDate"
                    value={this.state.dueDate}
                    onChange={this.handleChange}
                />
            </div>

            <div className="col-12 mt-2 size-18 my-2">
            <label className="font-f-monst-sans size-18 fw-medium mb-0">Discussion</label>
            <Editor
                editorState={editorState}
                onEditorStateChange={this.handleEditorChange}
                wrapperClassName="wrapper-class"
                editorClassName="editor-class"
                toolbarClassName="toolbar-class"
                />
            </div>
          
            </div>

            </form>
            </Modal.Body>  
            <Modal.Footer className='my-3'>  
            <>{this.state.loading ? 'loading...' :<Button className="btn btn-success col-9" onClick={() => this.handleSubmit()}> Save Meeting Notes </Button>}</>
            <Button className="btn btn-danger col-2" onClick={() => this.handleModal()}> Cancel </Button>
            </Modal.Footer>  
         </Modal>
            </>
        )
    }
}
export default EditInternalNotes